import React, { Component } from "react";
import "./Education.scss";

function EducationCard(props) {
	return (
		<div className="education-card  col-12 col-sm-8 col-md-6 col-lg-4">
			<h4>{props.institution}</h4>
			<span>{props.city}</span>
			<ul>
				{props.values.map((e, i) => {
					return (
						<li key={i}>
							<p>{e}</p>
						</li>
					);
				})}
			</ul>

			<span className="date">{props.date}</span>
		</div>
	);
}

class Education extends Component {
	constructor() {
		super();

		this.eduactions = [
			{
				institution: "ESPOL",
				city: "Guayaquil",
				values: [
					"Member of the Phycom club and the free software community KOKOA.",
					"Participation in some hackathons: Nasa Space Apps, DataJam, PyWeekend and Arduino Day.",
				],
				date: "Computer Science Engineering Student",
			},
		];
	}

	render() {
		return (
			<div id="eduaction" className="eduaction">
				<div className="curved-education">
					<svg viewBox="0 0 1440 319">
						<path
							fill="#14213D"
							d="M0,288L34.3,293.3C68.6,299,137,309,206,293.3C274.3,277,343,235,411,197.3C480,160,549,128,617,133.3C685.7,139,754,181,823,208C891.4,235,960,245,1029,213.3C1097.1,181,1166,107,1234,85.3C1302.9,64,1371,96,1406,112L1440,128L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z"
						></path>
					</svg>
					<div className="education-items">
						<h3>Education</h3>
						{this.eduactions.map((e, i) => {
							return (
								<EducationCard
									key={i}
									institution={e.institution}
									city={e.city}
									values={e.values}
									date={e.date}
								/>
							);
						})}
					</div>

					<svg viewBox="0 0 1440 319">
						<path
							fill="#14213D"
							d="M0,288L34.3,293.3C68.6,299,137,309,206,293.3C274.3,277,343,235,411,197.3C480,160,549,128,617,133.3C685.7,139,754,181,823,208C891.4,235,960,245,1029,213.3C1097.1,181,1166,107,1234,85.3C1302.9,64,1371,96,1406,112L1440,128L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"
						></path>
					</svg>
				</div>
			</div>
		);
	}
}

export default Education;
